import {
    unref, Ref, computed, toRefs,
   } from 'vue';
import useProduct from '@ve/pages/hotel/use/useProduct';
import { IReturnProductType } from '@ve/pages/hotel/types';
import getCriteriaByRoomDate from '../services/getCriteriaByRoomDate';
import groupByProductCriterias from '../services/groupByProductCriterias';
import { IRoomCategories } from '../types';

export default function (props: { products: Ref<IReturnProductType[]>, takenRoomCategories: Ref<IRoomCategories[]> }) {
    const { products, takenRoomCategories } = props;

    const { firstProduct, getFirstProducts } = useProduct(products);

    const currentCategory = computed(() => getCriteriaByRoomDate(unref(firstProduct)));

    const currentTakenCategory = computed(() => unref(takenRoomCategories).find((roomCategory) => roomCategory.criteriaRoom === unref(currentCategory)));

    const filteredProductsByType = computed(() => unref(products).filter((product) => product.type === unref(currentTakenCategory)?.productType));

    const groupedProductsByProductCriteria = computed(() => groupByProductCriterias(unref(filteredProductsByType)));

    return {
        currentTakenCategory,
        filteredProductsByType,
        groupedProductsByProductCriteria,
        firstProduct,
        currentCategory,
        getFirstProducts,
    };
}
